import React from 'react'
import { styled, Box, Typography } from '@mui/material'

export const Menu = styled('ul')({
  padding: '20px 0 0 0',
  margin: 0,
  backgroundColor: 'rgba(255, 255, 255, 1)'
})

export const MenuItem = styled('li')({
  fontSize: '15px',
  color: 'rgba(28, 61, 100, 1)',
  display: 'flex',
  alignItems: 'center',
  fontWeight: 500,
  padding: '10px 10px 10px 16px',
  margin: '0px 16px',
  letterSpacing: '0.15px',
  cursor: 'pointer',
  '&:hover' : {
    backgroundColor: 'rgba(235, 245, 255, 1)',
    borderRadius: '4px'
  },
})

export const MenuItemIcon = styled('div')({
  fontSize: '20px',
  paddingLeft: '10px'
})
